import { Component } from '@angular/core';

@Component({
  selector: 'fgb-scorecard-nav',
  templateUrl: './scorecard-nav.component.html',
  styleUrl: './scorecard-nav.component.scss',
})
export class ScorecardNavComponent {}
